import { Component, OnInit, OnDestroy, Inject, NgZone, ViewChild, ElementRef, OnChanges, AfterViewInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConstantsService } from '../services/constants.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { DOCUMENT, DatePipe, Location } from '@angular/common';
import Player from '@vimeo/player';
import { Auth } from 'aws-amplify';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { CacheService } from '../services/cache.service';
import video from '../videos/videos';
import allVideos from '../videos/allVideos.json';
import campVdeo from '../../courtney/videos.js';
import { HostListener } from '@angular/core';
import {
  MatDialog,
} from '@angular/material/dialog';
import { StripePaymentComponent } from '../stripe-payment/stripe-payment.component';
import { Meta } from '@angular/platform-browser';
import { GetPaymentService } from '../services/get-payment.service';
import { MapSearchComponent } from '../map-search/map-search.component';
import { UserService } from '../services/user.service';
import { Title } from '@angular/platform-browser';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
import { SessionService } from '../services/session.service';
import CampaignConstants from '../../The_end_of_oak_street/constant';
// import { HelperService } from '../services/helper.service';

declare const gtag: Function;

@Component({
  selector: 'app-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.scss'],
})
export class WindowComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  currentItem;
  public Placesng: string = '';
  placeName = '';
  mapClose: boolean = false;
  fromHome = false;
  playvideo = false;
  newdata: any;
  public map;
  public countryList = this.constants.COUNTRY_LIST_TXT;

  currentPlayList = [];
  filteredVideos = false;
  selectedCountry: string
  tagvalue: any;
  backtoallvideos = false;
  emptyVideoList = false;
  isMapsearchResult = false;
  mobiletagmodule: boolean;
  closemobiletagmodule: boolean;
  showSearchDropdown: boolean = false;
  showBookmarkAlert = false
  hideTag = false;
  disableHandle = false;
  showAds = false;
  progress = 0;
  adsintervel;
  modifiedLocation =''
  tagSetter = {
    InteriorsLoader: false,
    RainLoader: false,
    NatureLoader: false,
    NightLoader: false,
    SnowLoader: false,
    AnimalsLoader: false,
    DayVideoLoader: false,
    CityLoader: false,
    WaterLoader:false,
  }
  alertSetter = {
    afterSuccessPrime: false,
    locationBeforeLogin: false,
    NonPrimeUser: false,
    becomePrimeUser: false,
    submitBeforeLogin: false,
    bookmarkLimitAert: false,
    bookmarkBeforeLogin: false,
    playlistRestrict: false,
    upgradeToPrimeAd:false
  }
  windowWidth;
  count = 1;
  startTime: any;
  endTime: any;
  time: any;
  showAdInNextTenth: any = false;
  showAdInNextTenthNonLogin: any = false;
  constantsCampaign: any;
  showViatorLocal: boolean = false;
  campaingCountry: any;
  campaingSearchCountry: any;
  campaingLocalCountry: any;
  deviceInfo: any;
  blogUrl: string = '#';
  campaingSearchPlace: string;
  counterForViator: number = 0;
  mixpanelPlace: any;
  campaignordercounter: number = 0;
  campaignOrderCityCounter: number = 0;
  campaingSearchCountrySplited: any;
  viatorCampaignCityVideos: any;
  campaignOrderCityCounterBlog: number = 0;
  displayCounter: boolean = true;
  selectvideo: boolean = false;
  viatorBlogCityVideos: any;
  campaignCountryPortugal: boolean = false;
  campaignCountryPortugalText: string;
  Shuffled: boolean = false;
  watchedVideos: any = [];
  name: any;
  userWatchedVideo: any = [];
  tagLoaderKey: string;
  repeatingVideosRemoved = [];
  public videotagObservable: any;
  authorTwo: '';
  dateRecording: any = '';
  timeRecording: any = '';
  isSmallMobile:boolean = false;
  playerError: any;
  isVideoFailureTrackingEnabled: boolean = false;
  isNewVideoLoaded: boolean;
  isSwitchingWindow:boolean;
  isHandleClickAllowed: boolean = true;
  campaignName: string = environment.CAMPAIGN_NAME;
  isCampaignEnabled: boolean = environment.IS_CAMPAIGN_ENABLED;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isSmallMobile = false;
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.playerHeight = this.screenHeight;
    if (this.screenWidth <= 970 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `${this.screenHeight}px`;
      // this.playerHeight = this.screenWidth;
    }
    if(this.screenWidth<this.screenHeight && this.screenWidth<=375 && this.screenHeight<=667|| this.screenWidth>this.screenHeight && this.screenHeight<=375 && this.screenWidth<=667){
      this.isSmallMobile = true;
    }
  }
  public popUp = false;
  public sendTipsPop = false;
  public payment = false;
  public screenHeight;
  public screenWidth;
  public index;
  public shuffledArray = [];
  public muted = false;
  public isMobile = false;
  public isDesktop = false;
  public volume = 1;
  public isBookmark = null;
  public from = 'window';
  public emailAddress = 'hello@window-swap.com';
  public campaignConstants = CampaignConstants;
  private sub: any;
  public brandLogo = '';
  public campaignLogo = '';
  public StreamLogo = '';
  public musicLogo = '';
  public timeoutRef = undefined;
  public trailerButtonTimeoutRef = undefined;
  public counter = 0;
  public isVelux = false;
  public closenonprimepoup = false;
  public showContainer = false;
  public playerHeight;
  public videoItem: any = {}
  public author = "";
  public location = "";
  public player = null;
  public userName = null;
  public isLoading = false;
  public isLoop = false;
  public login = false;
  public shareUrl = null;
  public profilePicture = '';
  public isCampaign = false;
  public isArtists = false;
  public alertClose = true;
  public volumeup = false;
  public isFromWindow = false;
  public uploadedVideoList = [];
  public receivePayment = false;
  public accountId;
  public disablePrevButton = true;
  public videoCount = 15;
  public videoCountNonlogin = 10;
  public isPrime: any;
  public bookmarkedVideosInorder = []
  public shuffledBookmarkedVideos = []
  filtername: any;
  elem: any;
  checkValue = false;
  public fifteenthVideo = 0;
  public fifteenthVideoNonLogin = 0;
  private tenthVideo = 0;
  showViator: boolean = false;
  textCopied: boolean = false;
  currUserEmailId='';
  isSuperUser: boolean = false;
  constructor(
    public dialog: MatDialog,
    public deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private authenticate: CacheService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private zone: NgZone,
    private meta: Meta,
    public constants: ConstantsService,
    private paymentService: GetPaymentService,
    private userService: UserService,
    public title: Title,
    private previousPage: Location,
    private mixpanel: SharedMixpanelService,
    private datePipe: DatePipe,
    private sessionService: SessionService,
    // private helperService: HelperService
  ) {
    this.isMobile = this.deviceService.isMobile();
    this.isDesktop = this.deviceService.isDesktop();
    this.muted = true;
    this.volume = 0;
  }

  @Component({
    selector: 'ngbd-tooltip-basic',
    templateUrl: './tooltip-basic.html',
  })

  load = async () => {
    if (`${environment.CAMPAIGN_TYPE}` === 'window' && `${environment.CAMPAIGN_NAME}` === 'viator') {
      this.constantsCampaign = await import(
        `../../${environment.CAMPAIGN_NAME}/constant.js`
      );
      this.viatorCampaignCityVideos = await import(
        `../../${environment.CAMPAIGN_NAME}/viator-campaign-cities.json`
      );
      this.viatorBlogCityVideos = await import(
        `../../${environment.CAMPAIGN_NAME}/viator-blog-cities.json`
      );
    }
    if (this.from === 'cityVideos') {
      return this.currentPlayList;
    }
    if (this.from === 'bookmarkedWindow') {
      return this.currentPlayList;
    }
    if (this.from === `${environment.CAMPAIGN_URL}` && `${environment.CAMPAIGN_TYPE}` === 'campaign') {
      const videos = await import(
        `../../${environment.CAMPAIGN_NAME}/videos.js`
      );
      const constants = await import(
        `../../${environment.CAMPAIGN_NAME}/constant.js`
      );
      this.campaignConstants = constants.default;
      return videos.default;
    } else if (this.from === 'window') {
      if (this.isPrime) {
        if (this.filteredVideos) {
          return this.currentPlayList;
        } else {
          let video = allVideos['allVideos'];
          if (this.userWatchedVideo !== undefined) {
            if (this.userWatchedVideo.length > 0) {
              video.forEach((element, i) => {
                let found = false;
                this.userWatchedVideo.forEach(data => {
                  if (data === element.url1) {
                    found = true;
                  }
                  if (found) {
                    video.splice(i, 1);
                    found = false;
                  }
                });
              });
            }
          }
          this.repeatingVideosRemoved = video;
          return video;
        }
      } else {
        return video;
      }
    } else {
      const favVideo = `${environment.CAMPAIGN_TYPE}` === 'window' && `${environment.CAMPAIGN_NAME}` === 'viator' ?
        [...this.viatorBlogCityVideos?.viatorBlogCities[0], ...this.viatorCampaignCityVideos?.viatorCampaignCities[0], ...await allVideos['allVideos']] : await allVideos['allVideos'];

      let currentVideo = favVideo.filter((data) => data.url1 === this.from);
      if (currentVideo.length === 0) {
        let video = this.getVideo();
        return video;
      } else {
        return currentVideo;
      }
    }
  };
  getVideo = async () => {
    let getVideo = [];
    const params = [
      { param: '{object}', value: 'getVideo' },
      { param: '{id1}', value: 'window' },
      { param: '{id2}', value: this.from },
    ];
    return await this.dataService
      .getData(this.urlConstants.getUri(this.urlConstants.getList, params)).toPromise() // This is required, otherwise this will return empty array
      .then(async (data) => {
        return (getVideo = [
          {
            url1: data['Item']['url1'],
            url2: data['Item']['url2'],
            author: data['Item']['author'],
            cityLocation: data['Item']['cityLocation'],
            emailId: data['Item']['emailId'],
            vimeoToken: data['Item']['vimeoToken']
          },
        ]);
      }).catch(error => this.router.navigate(['/']));
  };

  hideUI = () => {
    if (this.videoItem?.areControlsFreezed){
      return
    }
    if (!this.isMapsearchResult) {
      this.authenticate.animateUI('easeout-right');
      this.authenticate.animateUI('hide-ui');
    }
    this.authenticate.animateUI('easeout-top');
    this.authenticate.animateUI('campaign-hide');
    this.authenticate.animateUI('easeout-bottom');
  };
  showUI = () => {
    if (!this.isMapsearchResult) {
      this.authenticate.animateUI('easein-right');
      this.authenticate.animateUI('show-ui');
    }
    this.authenticate.animateUI('campaign-view');
    this.authenticate.animateUI('easein-bottom-top');
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
    this.timeoutRef = setTimeout(this.hideUI, 5000);
  };
  shuffle = (videos) => {
    var j, x, i;
    for (i = videos.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = videos[i];
      videos[i] = videos[j];
      videos[j] = x;
    }
    return videos;
  };
  volumUp = () => {
    window.addEventListener('mousedown', (e) => {
      this.authenticate.animateUI('show-ui');
      if (this.isMapsearchResult) {
        this.authenticate.animateUI('map-nav-easeout');
      }
      if (this.timeoutRef) {
        clearTimeout(this.timeoutRef);
      }
      this.timeoutRef = setTimeout(this.hideUI, 5000);
      if (this.volumeup === false) {
        if (!this.isCampaign) {
          if (JSON.parse(localStorage.getItem('Volume')) !== null) {
            this.volume = JSON.parse(localStorage.getItem('Volume')).volumeLevel;
            this.muted = JSON.parse(localStorage.getItem('Volume')).muted;
          } else {
            this.muted = !this.muted;
            this.volume = this.muted ? 0 : 0.5;
          }
        }
        this.adjustVolume(true);
      }
      this.volumeup = true;
    });
  };
  handleClick = async() => {
    this.isSwitchingWindow = true
    if (!this.isHandleClickAllowed) {
      return;
    }
    this.isHandleClickAllowed = false;
    this.mixpanel.actions.track('Watched Video', {
      Email: this.userName,
      Video: this.videoItem
    });
    this.count++;
    if (!this.isPrime && this.login || !this.isPrime && !this.login) {
      this.fifteenthVideo++;
    }
   
    // if (this.login && this.isPrime) {
    if (!this.isMapsearchResult) {
      this.closeTagmodule();
    }
    this.closemobiletagmodule = true;
    this.mobiletagmodule = false;
    // }

    if (this.videoNotFound) {
      this.player.destroy()
      this.textCopied = false;
      this.videoNotFound = false;
      this.playerError = null;
      this.isHandleClickAllowed = true;
      this.init();
      return
    }

    if (this.isFromWindow) {
      //this.router.navigate(['/Window']);
      window.location.href = '/Window'
      this.showBookmarkAlert = false;
      this.isFromWindow = false;
    }
    if (this.closenonprimepoup === true) {
      this.index = -1;
      this.closenonprimepoup = false;
    }
    if (this.index >= 200 && this.from === 'window' && !this.isPrime) {
      this.openWindowAlert('becomePrimeUser');
    } else {
      if (this.count === 5 && !this.isPrime && !this.login) {
        this.openWindowAlert('upgradeToPrimeAd');
      }
      if (this.count === 10 && !this.isPrime && this.login) {
        this.openWindowAlert('bookmarkBeforeLogin');
      }
      let firstVideoFromLogin = JSON.parse(localStorage.getItem('fromwindowBookmark-CurrentVideo'));
      this.index = (firstVideoFromLogin === null || firstVideoFromLogin.length === 0 ? this.index + 1 : this.index + 2) % this.shuffledArray.length;
      localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([]);
      this.videoItem = this.shuffledArray[this.index];
      if (this.isPrime && this.currentPlayList.length === 0 && this.from !== 'bookmarkedWindow' && this.from !== 'cityVideos') {
        this.watchedVideos.push(this.videoItem.url1);
        this.updateWatchedvideos();
      }
      this.hasBookmark();
      this.hasActivatedPayment();

      const isBrokenVideoFound = await this.isBrokenVideo(this.videoItem.url1, this.videoItem.url2);
      if (isBrokenVideoFound){
        this.isHandleClickAllowed = true;
        await this.handleClick();       
        return;  
      }
      this.isHandleClickAllowed = true;
      try {

        if (this.isNewVideoLoaded === false) {
          await this.player.destroy();
          await this.initPlayer(this.videoItem);
        } else {
          // Load the new video into the existing iframe
          this.isNewVideoLoaded = false
          await this.player.loadVideo({
            url: `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
            autoplay: true,
            muted: this.muted
          });
          this.isNewVideoLoaded = true
          this.isSwitchingWindow = false
        }
        // await this.player.destroy();
        // await this.initPlayer(this.videoItem);
        this.setDefaultVolume();
        // await this.player.loadVideo({url: `https://player.vimeo.com/video/${this.videoItem?.url1}?h=${this.videoItem?.url2}`,})
        this.proceedToPlayVideo(false);
      } catch (error) {
        console.log("****PLAYER ERROR**** LOAD FAILURE AT HANDLE-CLICK:",error);
         
            this.videoNotFound = true;
            this.playerError = error.message + 'from handleclick';
            if(this.isVideoFailureTrackingEnabled){

              this.mixpanel.actions.track('video-error', {
                Email: this.userName,
                error: "****PLAYER ERROR**** LOAD FAILURE AT HANDLE-CLICK:" + error.message,
                VideoUrl: this.videoItem.url1,
              });
            }
      }

      this.shareUrl = this.videoItem;
      this.authenticate.set(this.shareUrl);
      if (!this.isPrime && this.from === 'window') {
        localStorage['lastIndex'] = JSON.stringify(this.index);
      } else {
        localStorage['lastIndex'] = JSON.stringify(0);
      }
      if (this.index !== 0) {
        this.disablePrevButton = false;
      }
    }
  };
  
  checkIfIpad():boolean{
    const userAgent = navigator.userAgent || navigator.vendor;
    // Check for newer iPads in desktop mode
    if (/Macintosh/.test(userAgent)) {
      if (typeof navigator.maxTouchPoints !== 'undefined' && navigator.maxTouchPoints > 0) {
        return false; // iPad in desktop mode
      }
      // Fallback for older iPads in desktop mode
      if ('ontouchstart' in window) {
        return false; // Older iPad in desktop mode (has touch support)
      }
    }
    // Check for old iPads in desktop mode
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return false; // Old iPad in mobile mode
    }
    return true;
  }
  // handleShowAds = () => {
  //   if (this.from !== 'window') return;
  //   if (this.isPrime) return;
  //   else {
  //     this.player.pause();
  //     this.showAds = true;
  //     this.adsintervel = setInterval(() => {
  //       if (this.progress >= 103) {
  //         clearInterval(this.adsintervel);
  //         this.showAds = false;
  //         this.player.play();
  //         this.progress = 0;
  //       }
  //       else {
  //         if (this.document.getElementById("progress-bar") === null) {
  //           clearInterval(this.adsintervel);
  //           this.showAds = false;
  //           this.player.play();
  //           this.progress = 0;
  //         } else {
  //           this.document.getElementById("progress-bar").style.width = this.progress + "%";
  //           this.progress = this.progress + 20;
  //         }
  //       }
  //     }, 1000)
  //   }
  // }
  onClickPrevious = async () => {
    if (!this.isHandleClickAllowed) {
      return;
    }
    this.isHandleClickAllowed = false;
    this.index = (this.index - 1) % this.shuffledArray.length;
    this.videoItem = this.shuffledArray[this.index];
    this.hasBookmark();
    this.hasActivatedPayment();
    const isBrokenVideoFound = await this.isBrokenVideo(this.videoItem.url1, this.videoItem.url2);
    this.isHandleClickAllowed = true;
    if (isBrokenVideoFound){
      this.onClickPrevious();
      return;
    }
    this.player.loadVideo({
      url: `https://player.vimeo.com/video/${this.videoItem?.url1}?h=${this.videoItem?.url2}`,
    }).then(() => {
      this.proceedToPlayVideo(false);
    }).catch(error => {
      console.log("****PLAYER ERROR**** LOAD FAILURE AT PREVIUOS():",error);

        if(this.isVideoFailureTrackingEnabled){

          this.mixpanel.actions.track('video-error', {
            Email: this.userName,
            error: "****PLAYER ERROR**** LOAD FAILURE AT PREVIUOS() :" + error.message,
            VideoUrl: this.videoItem.url1,
          });
        }      
    });
    this.shareUrl = this.videoItem;
    this.authenticate.set(this.shareUrl);
    if (this.index === 0) {
      this.disablePrevButton = true;
    }
  };
  onClickGoBack = () => {
    this.index = -1;
    localStorage['lastIndex'] = JSON.stringify(this.index);
    this.handleClick();
  };
  toggleVolume = () => {
    this.muted = !this.muted;
    let defaultVolume = 0.5;
    let selectedVolume = JSON.parse(localStorage.getItem('Volume')).volumeLevel;
    this.volume = this.muted ? 0 : (selectedVolume || defaultVolume);
    this.adjustVolume(false);
  };

  setDefaultVolume() {
    if (!this.isCampaign) {
          
        if (JSON.parse(localStorage.getItem('Volume')) !== null) {
          this.volume = JSON.parse(localStorage.getItem('Volume')).volumeLevel;
          this.muted = JSON.parse(localStorage.getItem('Volume')).muted;
          if(this.volume > 0 && !this.muted){
            if(this.isDesktop && this.checkIfIpad()){

              this.player.setMuted(this.muted);
              this.player.setVolume(this.volume);
      
              let x = this.volume * 100;
              let colour =
                'linear-gradient(90deg, rgb(202,115,88)' +
                x +
                '%, rgb(214,214,214)' +
                x +
                '%)';
              let slider = this.document.getElementById('slider');
              slider.style.background = colour;

            }else{

              this.volume = 0;
              this.muted = true;
              this.player.setMuted(this.muted);
              this.player.setVolume(this.volume);

              let x = this.volume * 100;
              let colour =
                'linear-gradient(90deg, rgb(202,115,88)' +
                x +
                '%, rgb(214,214,214)' +
                x +
                '%)';
              let slider = this.document.getElementById('slider');
              slider.style.background = colour;
              this.volumeup = false;
              this.volumUp();
            }
          }
        }   

    }

  }


  toggleFavorite = () => {
    if (!this.isBookmark) {
      this.addBookmark();
    } else {
      this.removeBookmark();
    }
  };
  nonloginFavorite() {
    this.authenticate.sendEvent();
  }
  share() {
    this.authenticate.set(this.shareUrl);
    this.authenticate.sendEvent();
  }

  toggleLoop = () => {
    this.isLoop = !this.isLoop;
    localStorage['Loop'] = JSON.stringify(this.isLoop);
    this.player && this.player.setLoop(this.isLoop)
  };
  goHome = () => {
    this.router.navigate(['/']);
  };

  public async authcall() {
    this.authenticate.getAuthUser()
      .then(async (data) => {
        let { email, picture, login, userName, given_name } = data;
        this.login = login;
        this.profilePicture = picture;
        this.userName = email;
        this.name = userName;
        this.isLoading = false;
        if (login) {
          await this.userService.getUser(true).then(async data => {
            this.currUserEmailId=data.email;
            if (this.constants.SUPER_USER.includes(this.currUserEmailId)) {
              this.isSuperUser = true;
            }
            let { isPrime } = data
            this.isPrime = isPrime;
            this.isCampaignEnabled = environment.IS_CAMPAIGN_ENABLED && !isPrime;
            if (isPrime) {
              if (localStorage.getItem('watchedVideos') !== "undefined") {
                this.userWatchedVideo = JSON.parse(localStorage.getItem('watchedVideos'));
                this.watchedVideos = [...this.userWatchedVideo];
              }
            } 
            //else {
              // The section below is commented out because Publift ads need to be removed.
              // if(this.isMobile){
              //   this.helperService.removeGlobalStyle();
              // }
            //}

            await this.init();
          })
        }
        else {
          // The section below is commented out because Publift ads need to be removed.
          // if(this.isMobile){
          //   this.helperService.removeGlobalStyle();
          // }
          this.isPrime = false
          this.isCampaignEnabled = environment.IS_CAMPAIGN_ENABLED;
          await this.init();
        }
      //  this.handleShowAds();
      })
  }
  videoNotFound = false;
  initPlayer = async (videoItem) => {
    this.player = await new Player('vimeo', {
      url: `https://player.vimeo.com/video/${videoItem.url1}?h=${videoItem.url2}`,
      // responsive: true,
      autoplay: true,
      autopause: false,
      muted: this.muted,
      // height: this.playerHeight, // enable this if we need video without crop
      height: 2000, // enable this if we need videofull screen
      controls: false,
      loop: this.from === 'window' || this.from === 'bookmarkedWindow' && this.isLoop === true ? true : false,
    })
    this.isNewVideoLoaded = true
    this.player.ready().catch((error) => {
      console.log("****PLAYER ERROR**** INIT FAILURE :",error);
      this.videoNotFound = true;
      this.playerError = error.message + "form init player";
      this.handleClick();
      if (this.isVideoFailureTrackingEnabled) {

        this.mixpanel.actions.track('video-error', {
          Email: this.userName,
          error: "****PLAYER ERROR**** INIT FAILURE :" + error.message,
          VideoUrl: this.videoItem.url1,
        });
      }
    });
    this.player.on('progress', (data) => {
      if (data.seconds > data.duration - 30 && !this.isLoop) {
        this.handleClick();
      }
    })
  }
  ngOnChanges() {
    this.currentItem = {
      'login': this.login,
      'prime': this.isPrime,
      'videoitem': this.videoItem
    }
  }
  async init() {
    let afterSuccessPrime = localStorage.getItem('afterSuccessPrime');
    if(afterSuccessPrime){
      localStorage.removeItem('afterSuccessPrime');
      this.openWindowAlert('afterSuccessPrime');
    }
    let video = this.currentPlayList.length === 0 ? await this.load() : this.currentPlayList;
    let firstVideoFromLogin = JSON.parse(localStorage && localStorage.getItem('fromwindowBookmark-CurrentVideo'));
    if (this.isCampaign && environment.NO_RANDOM_VIDEOS === true) {
      this.shuffledArray = video;
    } else if (this.isCampaign && environment.NO_RANDOM_VIDEOS === false) {
      this.shuffledArray = this.shuffle(video);
    } else if (this.from === 'window') {
      if (video.length > 250) {
        let first250videos = [];
        let balancevideos = [];
        for (let i = 0; i <= 249; i++) {
          first250videos.push(video[i])
        }
        for (let i = 250; i < video.length; i++) {
          balancevideos.push(video[i])
        }
        let finalVideo = [];
        finalVideo.push(...this.shuffle(first250videos), ...this.shuffle(balancevideos));
        this.shuffledArray = this.selectvideo ? finalVideo : this.isMapsearchResult ? video :
          this.viatorBlogCityVideos === undefined || this.viatorCampaignCityVideos === undefined ? finalVideo : await this.pushVideoBetween(finalVideo);
      }
      else {
        this.shuffledArray = this.selectvideo ? this.shuffle(video) : this.isMapsearchResult ? video :
          this.viatorBlogCityVideos === undefined || this.viatorCampaignCityVideos === undefined ? this.shuffle(video) : await this.pushVideoBetween(this.shuffle(video));
      }
    } else {
      const myVideo = video.filter((myFav) => myFav.url1 === this.from);
      if (myVideo.length === 0) {
        this.isArtists = true;
        this.shuffledArray = campVdeo.filter((data) => data.url1 === this.from);
      } else {
        this.shuffledArray = myVideo;
      }
    }
    if (this.isPrime || this.from !== 'window') {
      this.index = 0;
    } else {
      this.index = JSON.parse(localStorage.getItem('lastIndex'));
      if (this.index === null) {
        this.index = 0;
      }
    }
    if (firstVideoFromLogin !== null) {
      if (firstVideoFromLogin?.length !== 0) {
        this.shuffledArray.splice(this.index === 0 ? 0 : this.index, 0, firstVideoFromLogin[0])
      }
    }
    if (this.from === 'cityVideos') {
      this.shuffledArray = video;
    }
    // checking is from bookmark and has only url
    if (this.from === 'bookmarkedWindow') {
      this.shuffledArray = this.Shuffled ? this.shuffledBookmarkedVideos : this.bookmarkedVideosInorder;
    }

    // For campaign mode, add the campaign video as the second video.
    if (this.isCampaignEnabled) {
      const campaignVideo = this.campaignConstants?.CAMPAIGN_CONFIG?.campaignVimeoData;
      if (campaignVideo && !this.shuffledArray.some((item) => item?.url1 === campaignVideo.url1)) {
        this.shuffledArray.splice((this.index + 1), 0, campaignVideo);
      }
    }
    
    this.videoItem = this.shuffledArray[this.index];
    if (this.isPrime && this.currentPlayList.length === 0 && this.from !== 'bookmarkedWindow' && this.from !== 'cityVideos') this.watchedVideos.push(this.videoItem.url1);
    if (this.videoItem?.url1 === this.from && this.isFromWindow) {
      this.from = 'window';
    }
    if (this.playvideo === true) {
      this.player?.loadVideo({
        url: `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
      })
        .then(() => {
          this.proceedToPlayVideo(true);
        }).catch(error => {
          console.log("****PLAYER ERROR**** LOAD FAILURE AT INIT():",error);
            this.handleClick();
          if (this.isVideoFailureTrackingEnabled) {

            this.mixpanel.actions.track('video-error', {
              Email: this.userName,
              error: "****PLAYER ERROR**** LOAD FAILURE AT INIT() :" + error.message,
              VideoUrl: this.videoItem.url1,
            });
          }
        });
      this.playvideo = false;
    } else {
      await this.initPlayer(this.videoItem)
      this.location = this.videoItem.cityLocation.replace(/ -/g, ',');
      this.author = this.videoItem.author;
      if (this.videoItem.dateRecording != undefined) {
        const timestamp = this.videoItem.dateRecording;
        const date = new Date(timestamp * 1000);
        this.dateRecording = this.datePipe.transform(date, 'MMMM yyyy');
      } else {
        this.dateRecording = ''
      }
      this.timeRecording = this.videoItem.timeRecording ? this.videoItem.timeRecording : '';
      setTimeout(() => {
        this.hideLoader();
      }, 5000);
      this.showLocalBlogandVitroData();
    }
    localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([]);
    this.hasActivatedPayment();
    this.hasBookmark();
    if (this.isCampaign && environment.NO_RANDOM_VIDEOS === true) {
      this.player.pause();
    }
    this.shareUrl = this.videoItem;
    this.authenticate.set(this.shareUrl);

    setTimeout(this.hideUI, 5000);
    window.addEventListener('mousemove', (e) => {
      this.showUI();
    });
    window.addEventListener('touchstart', (e) => {
      this.showUI();
    });

    this.player?.play().then(() => {
      this.volumUp();
    }
    ).catch(() => {
      console.log('error playing video');
    }
    );
  }

  async pushVideoBetween(final) {
    let campaingBlogCountry;
    let finaldata = [];
    for (let i = 0; i < this.viatorBlogCityVideos?.viatorBlogCities[0].length; i++) {
      campaingBlogCountry = this.viatorBlogCityVideos?.viatorBlogCities[0][i].cityLocation.toUpperCase();
      for (let i = 0; i < final.length; i++) {
        let Country = final[i].cityLocation.split(' - ')[0]?.toUpperCase();
        let SearchPlace = final[i].cityLocation.split(' - ')[1]?.toUpperCase();
        if (campaingBlogCountry === Country) {
          finaldata.push(final[i]);
          final.splice(i, 1)
        }
        if (campaingBlogCountry === SearchPlace) {
          finaldata.push(final[i]);
          final.splice(i, 1)
        }
      }
    }
    final = this.getOrderCampaingList(finaldata, final);
    return final;
  }
  async getOrderCampaingList(finaldata, final) {
    let counter = 1;
    let counterForViatorCity = 3;
    if (this.campaignordercounter === 0) {
      localStorage['lastIndex'] = JSON.stringify(0);
    }
    finaldata = this.viatorBlogCityVideos === undefined ? finaldata : [...this.viatorBlogCityVideos?.viatorBlogCities[0], ...finaldata]
    finaldata = this.shuffle(finaldata)
    for (let j = 0; j < finaldata.length; j++) {
      final.splice(counter, 0, finaldata[this.campaignordercounter]);
      this.campaignordercounter++;
      // counter = counter > 32 ? counter + 5 : counter + 4;
      counter = counter + 5;
    }
    // let viatorcampaignvideos = this.shuffle(this.viatorCampaignCityVideos?.viatorCampaignCities[0]);
    // for (let j = 0; j < viatorcampaignvideos.length; j++) {
    //   final.splice(counterForViatorCity, 0, viatorcampaignvideos[this.campaignOrderCityCounter]);
    //   this.campaignOrderCityCounter++;
    //   counterForViatorCity = counterForViatorCity + 5;
    // }
    return final;
  }

  showLocalBlogandVitroData() {
    if (this.viatorBlogCityVideos === undefined || this.viatorCampaignCityVideos === undefined) {
      return;
    }
    this.showViatorLocal = false;
    this.showViator = false
    this.counterForViator = Math.floor(Math.random() * 1);
    let data = [];
    this.campaingSearchCountry = this.location.toUpperCase();
    this.campaingSearchCountrySplited = this.location.toUpperCase();
    this.campaingSearchPlace = this.location.toUpperCase();
    if (this.location.includes('-')) {
      this.campaingSearchCountry = this.location.split(' - ')[0].toUpperCase();
      this.campaingSearchCountrySplited = this.location.split(' - ')[0].toUpperCase();
      this.campaingSearchPlace = this.location.split(' - ')[1].toUpperCase();
      if (this.campaingSearchCountry.includes('-')) {
        this.campaingSearchCountry = this.campaingSearchCountry.split('-')[0].toUpperCase();
        this.campaingSearchCountrySplited = this.campaingSearchCountrySplited.split('-')[1].toUpperCase();
      } else if (this.campaingSearchCountry.includes(',')) {
        this.campaingSearchCountry = this.campaingSearchCountry.split(',')[0].toUpperCase();
        this.campaingSearchCountrySplited = this.campaingSearchCountrySplited.split(',')[1].toUpperCase();
      }
    }
    if (this.campaingSearchCountry === "CAPE TOWN, SOUTH AFRICA" || this.campaingSearchCountry === "SOUTH AFRICAN SAFARI" || this.campaingSearchCountry === "PORTUGAL") {
      this.campaignCountryPortugal = false;
      this.viatorCampaignCityVideos.viatorCampaignCities[0].forEach((element) => {
        this.campaingLocalCountry = element.cityLocation.toUpperCase();
        let location = this.location.toUpperCase();
        if (this.campaingLocalCountry === location) {
          this.displayCounter = true;
          data.push(element);
          if (data.length > 1) {
            this.counterForViator = Math.floor(Math.random() * data.length);
          }
          this.blogUrl = data[this.counterForViator].link;
          this.showViator = true
          this.mixpanelPlace = this.campaingLocalCountry;

        }
      });
      this.mixpanel.actions.track('Viators Window', {
        'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
        'Location': this.mixpanelPlace,
        'Blog Url': this.blogUrl
      });
      if (this.campaingSearchCountry === "PORTUGAL") {
        this.campaignCountryPortugal = true;
        let url = this.blogUrl.split('/');
        if (url[5].includes('Douro-Valley-Wine-Tour-with-Lunch-Tastings-and-River')) {
          this.campaignCountryPortugalText = 'Douro Valley Wine Tour';
          this.mixpanel.actions.track('Viators ' + this.campaignCountryPortugalText + ' Window', {
            'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
            'Location': this.mixpanelPlace,
            'Blog Url': this.blogUrl
          });
        } else if (url[5].includes('Douro-Valley-Historical-Tour-with-Lunch-Winery-Visit-with')) {
          this.campaignCountryPortugalText = 'Douro Valley Historical Tour';
          this.mixpanel.actions.track('Viators ' + this.campaignCountryPortugalText + ' Window', {
            'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
            'Location': this.mixpanelPlace,
            'Blog Url': this.blogUrl
          });
        } else {
          this.campaignCountryPortugalText = 'Porto City Tour';
          this.mixpanel.actions.track('Viators ' + this.campaignCountryPortugalText + ' Window', {
            'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
            'Location': this.mixpanelPlace,
            'Blog Url': this.blogUrl
          });
        }
      }
    } else {
      this.viatorBlogCityVideos.viatorBlogCities[0].forEach((element) => {
        this.campaingLocalCountry = element.cityLocation.toUpperCase();
        let location = this.location.toUpperCase();
        if (this.campaingLocalCountry === location ||
          this.campaingLocalCountry === this.campaingSearchCountry ||
          this.campaingLocalCountry === this.campaingSearchPlace ||
          this.campaingLocalCountry === this.campaingSearchCountrySplited) {
          this.displayCounter = true;
          data.push(element);
          if (data.length > 1) {
            this.counterForViator = Math.floor(Math.random() * data.length);
          }
          this.blogUrl = data[this.counterForViator].link;
          this.showViatorLocal = true
          this.mixpanelPlace = this.campaingLocalCountry;
        }
      });
      if (!this.showViatorLocal) {
        return;
      }
      this.mixpanel.actions.track('Viators Blog Window', {
        'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
        'Location': this.mixpanelPlace,
        'Blog Url': this.blogUrl
      });
    }
    if (this.showViatorLocal && this.showViator) {
      setTimeout(() => {
        this.closeTagmodule();
      }, 1000);
    }
    if (this.showViatorLocal) {
      setTimeout(() => {
        this.closeTagmodule();
      }, 1000);
    }
    if (this.showViator) {
      setTimeout(() => {
        this.closeTagmodule();
      }, 1000);
    }
  }

  blogClicked() {
    this.mixpanel.actions.track('Viators ' + this.mixpanelPlace + ' Blog Button Click', {
      'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
      'Location': this.mixpanelPlace,
      'Blog Url': this.blogUrl
    });
    window.open(this.blogUrl, '_blank');
  }
  viatorClicked() {
    this.mixpanel.actions.track('Viators ' + this.mixpanelPlace + ' Click', {
      'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
      'Location': this.mixpanelPlace,
      'Blog Url': this.blogUrl
    });
    if (this.campaignCountryPortugal) {
      this.mixpanel.actions.track('Viators ' + this.campaignCountryPortugalText + ' Click', {
        'Video Url': `https://player.vimeo.com/video/${this.videoItem.url1}?h=${this.videoItem.url2}`,
        'Location': this.mixpanelPlace,
        'Blog Url': this.blogUrl
      });
    }
  }

  windowClose() {
    window.close();
  }
  hideLoader() {
    this.tagSetter.InteriorsLoader = false;
    this.tagSetter.RainLoader = false;
    this.tagSetter.NatureLoader = false;
    this.tagSetter.NightLoader = false;
    this.tagSetter.SnowLoader = false;
    this.tagSetter.AnimalsLoader = false;
    this.tagSetter.DayVideoLoader = false;
    this.tagSetter.CityLoader = false;
    this.tagSetter.WaterLoader = false;
    this.backtoallvideos = false;
    this.emptyVideoList = false;
  }
  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.router.navigateByUrl('/Window', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/Window']);
    });
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.startTime = new Date();
    this.onResize();
    this.sub = this.route.params.subscribe(async (params) => {
      let currentUrl = document.URL.split('/');
      this.from = currentUrl.slice(3).toLocaleString().toLowerCase();
      if (this.from === environment.CAMPAIGN_URL) {
        this.isCampaign = true;
        this.alertClose = true;
        this.meta.addTags([
          { property: 'og:title', content: 'Courtney Barnett x WindowSwap' },
          {
            property: 'og:description',
            content:
              'Listen to Courtney Barnett’s latest single ‘Rae Street’ through her fan’s windows.',
          },
        ]);
      }
      if (this.from[1] === ',') {
        this.from = this.from.slice(2);
      } else if (this.from[6] === ',') {
        this.from = this.from.slice(7);
        this.isFromWindow = true;
      }
      await this.authcall();
      this.videotagObservable = this.paymentService.videoTagCast.subscribe((data) => {
        this.fromHome = data.fromHome;
        this.userName = data.userName;
        if (this.fromHome) {
          if (data.result !== undefined) {
            this.renderMapsearch(data.result)
          }
          else {
            this.filterVideos(data.value);
          }
        }
      });
    });
    // if (JSON.parse(localStorage.getItem('Loop')) === true) {
    //   this.toggleLoop();
    // }
    if (history && history.state && history.state.data !== undefined) {
      this.from = 'bookmarkedWindow';
      this.bookmarkedVideosInorder = history.state.data;
      this.Shuffled = JSON.parse(localStorage.getItem('shuffle'))
      this.shuffledBookmarkedVideos = [this.bookmarkedVideosInorder[0], ...this.shuffle(this.bookmarkedVideosInorder.slice(1, this.bookmarkedVideosInorder.length))];
    }
    if (history && history.state && history.state.cityVideo !== undefined) {
      this.from = 'cityVideos';
      this.currentPlayList = history.state.cityVideo;
    }
  }
  ngAfterViewInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // if (!this.isPrime) {
    //   const fusetag = window['fusetag'] || (window['fusetag'] = { que: [] });
    //   fusetag.que.push(function () {
    //     fusetag.pageInit({ blockingFuseIds: ['23174194657'] });
    //   });
    //   fusetag.que.push(function () {
    //     fusetag.registerZone('window-vrec');
    //   });
    // }
  }
  ngOnDestroy() {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
    this.endTime = new Date();
    var diff = this.endTime.getTime() - this.startTime.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
    this.time = { day: days, hour: hours, minute: minutes, second: seconds };
    this.mixpanel.actions.track("Time spent watching a window", {
      "Time": this.time,
      "Start time": this.startTime.getTime(),
      "End time": this.endTime.getTime()
    });
    this.mixpanel.actions.track("No: of videos watched", {
      "Video Count": this.count
    });
    this.sub.unsubscribe();
    this.tagSetter[this.tagLoaderKey] = false;
    if (this.videotagObservable !== undefined) this.videotagObservable.unsubscribe();
    if (this.trailerButtonTimeoutRef) clearTimeout(this.trailerButtonTimeoutRef);
    this.sessionService.removeItem('authorObj');
  }
  public hasBookmark = async () => {
    const params = [
      { param: '{object}', value: 'getBookmark' },
      { param: '{id1}', value: this.userName },
      { param: '{id2}', value: `${this.videoItem?.url1}` },
    ];
    try {
      this.isLoading = true;
      let bookmarkObj = await this.dataService
        .getData(
          this.urlConstants.getUri(this.urlConstants.getSingleItem, params)
        )
        .toPromise();
      if (Object.keys(bookmarkObj).length === 0) {
        this.isBookmark = false;
      } else {
        this.isBookmark = true;
      }
      this.isLoading = false;
    } catch (e) {
      this.isLoading = true;
      this.isBookmark = true;
    }
  };
  public hasActivatedPayment = async () => {
    const params = [
      { param: '{object}', value: 'getPayment' },
      { param: '{id1}', value: `get_email~${this.videoItem?.url1}` }, // email id is taken from backend using the video id
      { param: '{id2}', value: 'accept_payment' },
    ];
    try {
      await this.dataService
        .getData(this.urlConstants.getUri(this.urlConstants.getSingleItem, params)).subscribe((data) => {
          if (Object.keys(data).length === 0) {
            this.receivePayment = false;
          } else if (data['Item'].receivePayment) {
            this.receivePayment = true;
            this.accountId = data['Item'].accountId;
          } else {
            this.receivePayment = false;
          }
        }, () => this.receivePayment = false);
    } catch (e) {
      // console.log('error------0', e);
    }
  };
  public addBookmark = async () => {
    const params = [
      { param: '{object}', value: 'getBookmarkedItems' },
      { param: '{id1}', value: this.userName },
      { param: '{id2}', value: 'numberOfBookmars' },
    ];
    this.isLoading = true;
    await this.dataService
      .getData(this.urlConstants.getUri(this.urlConstants.getList, params))
      .subscribe(async (data) => {
        if (data['Items'].length >= 30 && !this.isPrime) {
          this.isLoading = false;
          this.openWindowAlert('bookmarkLimitAert');
        } else {
          const params = [{ param: '{object}', value: 'bookmarks' }];
          this.videoItem.vimeoToken !== undefined ? (this.videoItem.vimeoToken = this.videoItem.vimeoToken) : (this.videoItem.vimeoToken = this.constants.TP_VIMEO_TOKEN_TXT);
          const bodyObj = {
            userName: this.userName,
            videoId: `${this.videoItem.url1}`,
            url: `${this.videoItem.url1}/${this.videoItem.url2}`,
            location: this.videoItem.cityLocation,
            author: this.videoItem.author,
            vimeoToken: this.videoItem.vimeoToken,
            dateRecording: this.videoItem.dateRecording,
            timeRecording: this.videoItem.timeRecording
          };
          this.isLoading = true;
          await this.dataService
            .postData(this.urlConstants.getUri(this.urlConstants.createItem, params), JSON.stringify(bodyObj))
            .subscribe(() => {
              this.mixpanel.actions.track("BookMark", {
                "Email": bodyObj.userName,
                "Url": bodyObj.url,
                "Location": bodyObj.location,
                "video Details": this.videoItem,
                "Author": bodyObj.author,
                "dateRecording": bodyObj.dateRecording,
                "timeRecording": bodyObj.timeRecording
              });
              this.isBookmark = true;
              this.isLoading = false;
            }, () => {
              this.isLoading = false;
            })
        }
      });
  };
  public removeBookmark = async () => {
    const params = [{ param: '{object}', value: 'bookmarks' }];
    const bodyObj = {
      userName: this.userName,
      videoId: this.videoItem.url1,
    };
    this.isLoading = true;
    await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.deleteItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise()
      .then(() => {
        this.isBookmark = false;
        this.isLoading = false;
      })
      .catch(() => {
        this.isBookmark = false;
        this.isLoading = false;
      });
  };
  onPopupClose(event) {
    this.authenticate.onPlayMusic(true);
  }
  closeAlert() {
    document.getElementById('windowAlert').style.display = 'none';
    this.alertClose = true;
  }
  openWindowAlert(event) {
    this.alertSetter.NonPrimeUser = false;
    this.alertSetter.bookmarkLimitAert = false;
    this.alertSetter.locationBeforeLogin = false;
    this.alertSetter.bookmarkBeforeLogin = false;
    this.alertSetter.submitBeforeLogin = false;
    this.alertSetter.becomePrimeUser = false;
    this.alertSetter.afterSuccessPrime = false;
    this.alertSetter.playlistRestrict = false;
    this.alertSetter.upgradeToPrimeAd = false;
    this.alertSetter[event] = true;
    this.showBookmarkAlert = true
  }
  SetVolume(event) {
    this.volume = parseFloat(event.target.value);
    this.adjustVolume(true);
  }
  onMouseOver() {
    document.getElementById('user-menu').style.display = 'block';
  }
  onMouseLeave() {
    document.getElementById('user-menu').style.display = 'none';
  }
  showVolumSlider() {
    this.document.getElementById('slider').style.display = 'block';
    this.document.getElementById('slider-backdround').style.display = 'block';
    this.closeTagmodule();
  }
  hideVolumSlider() {
    this.document.getElementById('slider').style.display = 'none';
    this.document.getElementById('slider-backdround').style.display = 'none';
  }
  async logout() {
    try {
      await await Auth.signOut()
      this.userService.userData = undefined;
      this.userService.isFirstCall = true;
      this.mixpanel.actions.reset()
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      if (error.code === 'NotAuthorizedException') {
        console.error('Access Token has been revoked. Please log in again.');
        localStorage.clear();
        // Optionally redirect to login or show a message to the user
        this.router.navigate(['/login']);
      } else {
        console.error('Error signing out:', error);
      }
    }
  }
  async OnclickSayThanks() {
    let accountId = this.accountId;
    const params = [
      { param: '{actionName}', value: 'getEmailfromVideoId' }
    ]
    const postdata = {
      videoId: this.videoItem.url1
    }
   let resData : any =  await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).toPromise()
    let creatorsEmail = resData.emailId;
    let creatorName = this.videoItem.author;
    let data = {
      accountId: accountId,
      creatorsEmail: creatorsEmail,
      creatorName: creatorName,
    };
    this.authenticate.onPayPopOpen(data);
    (this.popUp = true),
      (this.sendTipsPop = false),
      (this.payment = false),
      this.dialog.open(StripePaymentComponent, { disableClose: true });
  }
  Takemetoprime() {
    if (!this.login) {
      this.router.navigate(['/signup']);
      localStorage['fromwindowBookmark'] = JSON.stringify(true);
      localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([this.videoItem]);
    }
    else {
      this.router.navigate(['/pricing']);
    }
  }
  TakemeTopricing(){
    this.router.navigate(['/pricing']);
  }
  async filterVideos(event) {
    if (this.isPrime === false) {
      this.openWindowAlert('playlistRestrict');
      return;
    }
    this.showViator = false;
    this.showViatorLocal = false;
    this.isMapsearchResult = false;
    if (!this.fromHome) {
      this.playvideo = true;
    }
    this.fromHome = false;
    this.currentPlayList = [];
    this.disablePrevButton = true;
    if (this.tagvalue !== event) {
      this.tagvalue = event;
      this.setTag(event);
      this.currentPlayList = await this.filterVideoOnTag(this.tagvalue);
      this.mixpanel.actions.track('Playlist-' + this.tagvalue, {
        Email: this.userName,
        Tag: this.tagvalue
      });
    }
    else {
      this.tagvalue = 'all';
      this.removeTag(event)
    }
    this.init();
  }
  async filterVideoOnTag(tagvalue): Promise<any> {
    this.selectvideo = true;
    this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - Playing ${tagvalue} Windows`);
    return await allVideos['allVideos'].filter(video => video[`${tagvalue}`] == true);
  }

  setTag(currentTag) {
    this.hideLoader()
    this.filteredVideos = true;
    this.tagLoaderKey = `${currentTag}Loader`;
    this.tagSetter[this.tagLoaderKey] = true;
  }
  removeTag(currentTag) {
    this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - the calmest place on the internet`);
    this.tagLoaderKey = `${currentTag}Loader`;
    this.filteredVideos = false;
    this.backtoallvideos = true;
    this.tagvalue = ''
    this.tagSetter[this.tagLoaderKey] = false;
  }
  opentagmodule() {
    this.showViator = false;
    this.showViatorLocal = false;
    this.document.getElementById('overlay_1').style.display = 'block';
    this.document.getElementById('IMAGE_FILTER').style.display = 'none';
  }
  openMobiletagmodule() {
    this.mobiletagmodule = true;
    this.closemobiletagmodule = false;
  }
  closemobiletag() {
    this.closemobiletagmodule = true;
    this.mobiletagmodule = false;
  }
  closeTagmodule() {
    if (this.from !== 'window') {
      return
    }
    if (!this.isMapsearchResult) {
      setTimeout(() => {
        this.document.getElementById('overlay_1').style.display = 'none';
        this.document.getElementById('IMAGE_FILTER').style.display = 'block';
      }, 1000);
    }
    this.closemobiletagmodule = true;
    this.mobiletagmodule = false;
  }

  onClickSearch() {
    this.player.pause();
    let data = {};
    if (this.isMapsearchResult) {
      this.isMapsearchResult = false;
      data['windowHeader'] = true;
    } else {
      data['windowHeader'] = false;
    }
    data['prime'] = this.isPrime;
    data['userName'] = this.userName;
    let dialogRef = this.dialog.open(MapSearchComponent, {
      data: data,
      panelClass: 'full-width-dialog',
      maxWidth: '100vw',
      maxHeight: '100vh',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.renderMapsearch(result);
    });
  }
  renderMapsearch(result) {
    if (this.from === 'bookmarkedWindow') {
      return;
    } else if (this.from === 'cityVideos') {
      return;
    } else {
      this.fromHome = false;
    }

    let { isWindowClose, videos, country, windowHeader } = result;
    this.Placesng = country;
    if (!isWindowClose) {
      this.map = new google.maps.Map(
        document.getElementById('winmaps') as HTMLElement,
        {
          center: { lat: -33.9, lng: 151.2 },
          zoom: 4,
          mapId: '23ff35f7f7f699db'
        }
      );
      this.disableHandle = false;
      this.emptyVideoList = false;
      this.filteredVideos = true;
      this.isMapsearchResult = true;
      this.selectvideo = false;
      this.disablePrevButton = true;
      this.currentPlayList = this.shuffleMapSearchArray(videos);
      this.showViatorLocal = false;
      this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - ${this.constants.TITLE.window} ${country}`);
      this.fromHome ? this.playvideo = false : this.playvideo = true;
      this.init();
    }
    else {
      this.player.play();
    }
    if (windowHeader) {
      this.load()
      this.isMapsearchResult = true;
    }
  }
  onClickCloseMapSearch() {
    this.currentPlayList = [];
    this.isMapsearchResult = false;
    this.filteredVideos = false;
    this.backtoallvideos = true;
    this.disablePrevButton = true;
    this.playvideo = true;
    this.from = 'window';
    this.tagvalue = ''
    this.campaignordercounter = 0;
    this.campaignOrderCityCounter = 0;
    this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - the calmest place on the internet`);
    this.currentPlayList = this.repeatingVideosRemoved;
    this.init();
  }
  onClickBackFromBookmark() {
    this.currentPlayList = [];
    this.tagvalue = ''
    this.from = 'window';
    this.isMapsearchResult = false;
    this.filteredVideos = false;
    this.backtoallvideos = true;
    this.disablePrevButton = true;
    this.playvideo = true;
    this.campaignordercounter = 0;
    this.campaignOrderCityCounter = 0;
    this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - the calmest place on the internet`);
    this.currentPlayList = this.repeatingVideosRemoved;
    this.init();
  }

  Close() {
    this.Placesng = '';
    this.placeName = '';
  }
  onSearch() {
    this.showUI();
    this.currentPlayList = allVideos['allVideos'];
    let filteredVideos;
    let filteredOnCountry = [];
    if (this.Placesng !== undefined || this.Placesng !== '' || this.Placesng !== null) {
      const input = document.getElementById("pac-input") as HTMLInputElement;
      const searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();
        this.disablePrevButton = true;
        this.Placesng = places[0].name;
        let searchingName = places[0].name.toUpperCase()
        let filter_data = {
          country: '',
          locality: '',
          administrative_area_level_1: ''
        };
        for (let element of places[0].address_components) {
          filter_data[element.types[0]] = element.long_name;
        }

        if (filter_data.locality === '' && filter_data.administrative_area_level_1 === '' && filter_data.country === '') {
          filteredVideos = this.currentPlayList.filter(video => video.cityLocation.toUpperCase().includes(searchingName.toUpperCase()));
        }
        else if (filter_data.locality === '' && filter_data.administrative_area_level_1 === '' && filter_data.country != '') {
          filteredVideos = this.filterOnCountry(searchingName.toUpperCase(), this.currentPlayList);
        }
        else {
          filteredOnCountry = this.filterOnCountry(filter_data.country.toUpperCase(), this.currentPlayList);
          if (filteredOnCountry.length > 0) {
            filteredVideos = this.searchOnLocality(searchingName, filteredOnCountry)
            if (filteredVideos.length === 0) {
              filteredVideos = this.searchOnLocality(filter_data.locality, filteredOnCountry)
              if (filteredVideos.length === 0) {
                filteredVideos = this.searchOnAdministrativeAreaLevel1(filter_data.administrative_area_level_1, filteredOnCountry)
              }
            }
          }
          else {
            filteredVideos = [];
          }
        }
        if (filteredVideos.length > 0) {
          this.currentPlayList = filteredVideos;
          this.disableHandle = false;
          this.emptyVideoList = false;
          this.playvideo = true;
          this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - ${this.constants.TITLE.window} ${this.Placesng}`);
          this.init();
        }
        else {
          this.emptyVideoList = true;
          this.player.pause();
          this.disableHandle = true;
        }
      })
    }
  }
  filterOnCountry(country, videos) {
    let filteredData;
    if (country === this.constants.COUNTRY_USA || country === this.constants.COUNTRY_USA_1 || country === this.constants.COUNTRY_USA_2) {
      country = this.constants.COUNTRY_USA;
    }
    else if (country === this.constants.COUNTRY_UK || country === this.constants.COUNTRY_UK_1) {
      country = this.constants.COUNTRY_UK;
    }
    else if (country === this.constants.COUNTRY_UAE || country === this.constants.COUNTRY_UAE_1) {
      country = this.constants.COUNTRY_UAE;
    }
    filteredData = videos.filter(video => video.cityLocation.toUpperCase().split(' - ')[1]?.includes(country));
    return filteredData;
  }
  searchOnLocality(location, videos) {
    let filteredData;
    filteredData = videos.filter(video => video.cityLocation.toUpperCase().split(' - ')[0]?.includes(location.toUpperCase()))
    return filteredData;
  }
  searchOnAdministrativeAreaLevel1(administrative_area_level_1, videos) {
    let filteredData;
    if (administrative_area_level_1 === '') {
      filteredData = videos;
    }
    else {
      filteredData = videos.filter(video => video.cityLocation.toUpperCase().split(' - ')[0].includes(administrative_area_level_1.toUpperCase()))
      if (filteredData.length === 0) {
        filteredData = videos;
      }
    }
    return filteredData;
  }
  requestFullscreen() {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    }
    this.checkValue = true;
  }

  closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
    this.checkValue = false;
  }
  zoomInzoomOut() {
    this.checkValue ? this.closeFullscreen() : this.requestFullscreen();
  }

  getCurrentTime() {
    let today = new Date();
    let hours = (today.getHours() < 10 ? '0' : '') + today.getHours();
    let minutes = (today.getMinutes() < 10 ? '0' : '') + today.getMinutes();
    let seconds = (today.getSeconds() < 10 ? '0' : '') + today.getSeconds();
    return hours + ':' + minutes + ':' + seconds;
  }
  onClickSkipAD() {
    clearInterval(this.adsintervel);
    this.showAds = false
    this.progress = 0;
    this.player.play();
    this.router.navigate(['/pricing']);
  }
  hide() {
    this.player.play();
    this.progress = 0;
    clearInterval(this.adsintervel);
    document.getElementById('ads-popup').style.display = 'none';
  }
  onClickContinue() {
    clearInterval(this.adsintervel);
    this.showAds = false
    this.player.play();
    this.progress = 0;
  }
  toMapView() {
    if (this.showViator) {
      return;
    }
    this.player.pause();
    let data = {};
    if (this.isMapsearchResult) {
      this.isMapsearchResult = false;
      data['windowHeader'] = true;
    } else {
      data['windowHeader'] = false;
    }
    data['prime'] = this.isPrime;
    data['videoItem'] = this.videoItem;
    let dialogRef = this.dialog.open(MapSearchComponent, {
      data: data,
      panelClass: 'full-width-dialog',
      maxWidth: '100vw',
      maxHeight: '100vh',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.renderMapsearch(result);
    });
  }
  toLogin() {
    this.router.navigate(['/login']);
    localStorage['fromwindowBookmark'] = JSON.stringify(true);
    localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([this.videoItem]);
  }
  goTOBookmark() {
    this.previousPage.back();
  }
  toggleShuffle() {
    this.Shuffled = !this.Shuffled;
    if (this.Shuffled) {
      localStorage['shuffle'] = JSON.stringify(true);
    } else {
      localStorage['shuffle'] = JSON.stringify(false);
    }
    this.init();
  }
  updateWatchedvideos() {
    if (this.watchedVideos.length >= this.constants.UPDATE_VIDEO_COUNT) this.watchedVideos.splice(0, this.watchedVideos.length - this.constants.UPDATE_VIDEO_COUNT)
    let arr;
    arr = this.watchedVideos;
    arr = arr.filter((item, index) => arr.indexOf(item) === index);
    const params = [
      { param: '{object}', value: 'user' },
    ];
    const bodyObj = {
      userName: this.name,
      watchedVideos: arr
    }
    this.dataService
      .postData(this.urlConstants.getUri(this.urlConstants.updateItem, params), JSON.stringify(bodyObj))
      .subscribe((data) => {
        // 
      }, err => {
        // 
      });
  }
  toSubmit() {
    this.router.navigate(['/submit']);
  }
  shuffleMapSearchArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1)); // Generate random index from 0 to i
      // Swap elements at i and j
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  async copyLinkToClipBoard() {
    let err = this.playerError;
    let erroBase64 = btoa(encodeURIComponent(err));
    let currentUrl = `${environment.DOMAIN}share.html?id=${this.videoItem?.url1} \n err_token : ${erroBase64}`;
    await navigator.clipboard.writeText(currentUrl)
    this.textCopied = true;
  }

  toSignUp() {
    this.router.navigate(['/signup']);
  }

  async redirectUser() {
    if (this.constants.SUPER_USER.includes(this.currUserEmailId)) {
      let videoId = this.videoItem.url1;
      const params = [
        { param: '{actionName}', value: 'getEmailfromVideoId' }
      ]
      const postdata = {
        videoId: videoId
      }
      let resData : any =  await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).toPromise()
      let email = resData.emailId;
      let Name = this.videoItem.author;
      let authorObj={
        "email":email,
        "name":Name,
      }
      this.sessionService.setItem('authorObj',authorObj);
      const url = this.router.createUrlTree(['./user/mywindow']).toString();
      window.open(url, '_blank');
    }
  }

  openInNewTab(url: string) {
    window.open(url, '_blank');
  }

  NavTo(url: string) {
    if (!url) {
      return;
    }
    this.openInNewTab(url);
  }

  trackGaEvent(eventName: string, params: Record<string, any> = {}) {
    if (typeof gtag !== 'function') {
      return;
    }

    try {
      gtag('event', eventName, params);
    } catch (error) {
      console.warn('GA event tracking failed', error);
    }
  }

  trackCampaignClick(event?: MouseEvent) {
    event?.stopPropagation();

    this.trackGaEvent(this.campaignConstants.CAMPAIGN_CONFIG.GA_EVENTS.CAMPAIGN_CLICK, {
      event_category: 'engagement',
      event_label: 'campaign_click',
      video_id: this.videoItem?.url1 ?? '',
      location: this.location || this.mixpanelPlace || '',
      destination_url: this.videoItem?.campignRedirectUrl || '',
    });

    this.NavTo(this.videoItem?.campignRedirectUrl);
  }

  watchTrailerClick(event?: MouseEvent) {
    event?.stopPropagation();

    this.trackGaEvent(this.campaignConstants.CAMPAIGN_CONFIG.GA_EVENTS.WATCH_TRAILER_CLICK, {
      event_category: 'engagement',
      event_label: 'watch_trailer_click',
      video_id: this.videoItem?.url1 ?? '',
      location: this.location || this.mixpanelPlace || '',
      destination_url: this.videoItem?.campaignTrailer || '',
    });

    this.NavTo(this.videoItem?.campaignTrailer);
  }

  proceedToPlayVideo(onInit : boolean){

    if(onInit){

      setTimeout(() => {
        this.hideLoader();
      }, 3000);
    }

    if (this.trailerButtonTimeoutRef) {
      clearTimeout(this.trailerButtonTimeoutRef);
      this.trailerButtonTimeoutRef = undefined;
    }
    if (this.videoItem?.isTimerEnabled) {
      this.videoItem.showTrailerButton = false;
      const activeVideoId = this.videoItem?.url1;
      this.trailerButtonTimeoutRef = setTimeout(() => {
        if (this.videoItem?.url1 === activeVideoId) {
          this.videoItem.showTrailerButton = true;
        }
      }, 60000);
    }

    if(this.videoItem.areControlsFreezed){
      this.showUI();
    }

    this.location = this.videoItem.cityLocation.replace( / -/g,',');
    this.author = this.videoItem.author;
    if (this.videoItem.dateRecording != undefined) {
      const timestamp = this.videoItem.dateRecording;
      const date = new Date(timestamp * 1000);
      this.dateRecording = this.datePipe.transform(date, 'MMMM yyyy');
    } else {
      this.dateRecording = ''

    }
    this.timeRecording = this.videoItem.timeRecording ? this.videoItem.timeRecording : '';
    this.showLocalBlogandVitroData();
    
      this.setDefaultVolume();

  }

  adjustVolume(saveVolume : boolean){

    !this.volume ? this.muted = true : this.muted = false;
    if(saveVolume) 
    localStorage['Volume'] = JSON.stringify({ volumeLevel: this.volume, muted: this.muted });

    this.player.setVolume(this.volume);
    this.player.setMuted(this.muted);

    let x = this.volume * 100;
    let colour =
      'linear-gradient(90deg, rgb(202,115,88)' +
      x +
      '%, rgb(214,214,214)' +
      x +
      '%)';
    let slider = document.getElementById('slider');
    slider.style.background = colour;
  }

  async isBrokenVideo(videoId: string, hash?: string): Promise<boolean> {
    try {
      // Build the URL with hash if provided
      let vimeoUrl = `https://vimeo.com/${videoId}`;
      if (hash) {
        vimeoUrl += `/${hash}`;
      }
      const response = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(vimeoUrl)}`);
      if (!response.ok && response.status === 404) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

}
